const font = {
	size: {
		xxxxx_large: '40px',
		xxxx_large: '33px',
		xx_large: '28px',
		xxx_large: '26px',
		x_large: '24px',
		large: '20px',
		l_medium: '22px',
		x_medium: '18px',
		medium: '17px',
		small_medium: '16px',
		small: '15px',
		input_text: '14px',
		x_small: '13px',
		xx_inputlabel: '12px',
		xx_small: '11px',
		xxx_small : '10px',
		button: '14px',
		xx_medium:'16px',
		xxxx_small: '8px'
	},
	weight: {
		light: 300,
		regular: 400,
		medium: 500,
		semiBold: 600,
		bold: 700,
	},
	lh: {
		reset: '100%',
		small: '125%',
		medium: '150%',
		large: '250%',
	},
};

export default font;
